import React from 'react';
 import { useTranslation } from 'react-i18next';
import RequisitionsReportsTableItem from './ProductReportsItem';

const RequisitionsReportsTable = ({ reportData }) => {
  const [t] = useTranslation('global');

  return (
    <div className='m-5 rounded-lg bg-white border border-gray-200 sticky top-0 z-10'>
      <div className="grid grid-cols-12 gap-3 px-4 mt-2 bg-white font-bold text-[#251658] text-sm rounded-t-2xl justify-between items-center border-b py-4">
     <div className="text-center col-span-1">#</div>
     <div className="text-center col-span-1">{t("reports.Permission_Number")}</div>
         <div className="text-center col-span-4">{t("reports.Warehouse")}</div>
         <div className="text-center col-span-2">{t("reports.Quantity")}</div>
         <div className="text-center col-span-2">{t("reports.Add_Subtract")}</div>
         <div className="text-center col-span-2">{t("reports.Date")}</div>
        </div>
       
        <div className='h-[calc(100vh-500px)] overflow-y-scroll custom-scrollbar'>

        {reportData.data.map((item, index) => (
          <RequisitionsReportsTableItem key={item.id} item={item} index={index} />
        ))}
     
     </div>
     </div>
  );
};

export default RequisitionsReportsTable;
